/**
 * 客户端、非生产环境下加载 VConsole
 * 非生产：dev / build:dev / build:uat 时显示
 * 生产环境可通过 URL 参数 ?vconsole=1 强制显示（便于真机调试）
 */
export default defineNuxtPlugin(() => {
	if (import.meta.server) return;

	const forceShow = typeof window !== 'undefined' && /[?&]vconsole=1/.test(window.location.search);
	const isProd = import.meta.env.MODE === 'production';
	if (!forceShow && isProd) return;

	import('vconsole')
		.then((mod: any) => {
			const VConsole = mod?.default ?? mod;
			if (typeof VConsole !== 'function') return;
			new VConsole();
			// 距离底部 160px（避免被底部栏遮挡）
			const style = document.createElement('style');
			style.id = 'vconsole-position';
			style.textContent = '#vc-trigger, .vc-switch { bottom: 160px !important; }';
			document.head.appendChild(style);
		})
		.catch(e => console.warn('[vconsole] 加载失败:', e));
});
